<template>
    <main class="page-content">

        <!-- Our Team  Philosophy -->
        <section class="well well-md text-md-left relative text_center_small">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-md-preffix-1">
                        <h2 data-text="Heart">The <br class="md-visible">
            Begining<br class="md-visible"></h2>

                        <p class="text-md-justify">The guiding force behind Elizabeth
              Skin Care is Elizabeth’s European
              background and her passion for
              beauty. As a young girl growing
              up in Poland, Elizabeth would
              watch her mother (a well-known
              singer) prepare for her stage
              performances. Elizabeth became
              fascinated with the way her mother
              artfully applied her makeup and
              cared for her skin. She began
              to envision a career in helping
              people improve the condition and
              appearance of their skin.
            </p>                        
                    </div>
                    <div class="col-md-4 col-md-preffix-1 offset-1">
                        <div class="image-wrap preffix-1 postfix-1 content-shift-up-1 img-width block-center content-foreground">
                            <img width="450" height="674" src="@/assets/images/page-2_img01.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="image-wrap-2 lg-visible">
                <img width="606" height="497" src="@/assets/images/page-2_img02.jpg" alt=""></div>
        </section>
       
        <section class="well well--inset-4 text-md-left relative text_center_small">
            <div class="container">
              <div class="row row-md-reverse">
                <div class="col-md-5 col-md-preffix-2 inset-3">
                    <h2 data-text="Mind">The<br class="md-visible">
                        Journey</h2>
                    <!--<h5 class="text-default">We are planning to provide unsurpassed full-service
                        consulting services to the Salon and Spa Industry.</h5>-->

                    <p class="offset-4 text-md-justify">Following her dream, Elizabeth came to New York in the 1980’s and began her professional training under the guidance of noted beauty experts such as </p>
                    <ul class="marked-list">
                      <li><a href="#">Ultissima Beauty Institute</a></li>
                      <li><a href="#">Christine Valmy International</a></li>
                      <li><a href="#">Germaine De Capuccini</a></li>
                      <li><a href="#">Lam School of Esthetics</a></li>
                      <li><a href="#">Casmara International</a></li>
                      <li><a href="#">Revitalight Skin Care System</a></li>
                      <li><a href="#">Berkowitz School Of Electrolysis</a></li>
                      <li><a href="#">Dr. Howard Sobel</a></li>
                      <li><a href="#">M’lis , Natural Therapy</a></li>
                      <li><a href="#">Lumavera - David Vargas</a></li>
                    </ul>

    
                    <!--<p class="text-md-justify">We will advise owners and potential owners on most aspects of salon and spa business
                        development from inception to completion and beyond. No project is too big or too small.
                        DreamSpa can manage the entire process or fill-in the “gaps”. In addition, DreamSpa has
                        tools available to make your project easier to manage including comprehensive timelines,
                        customized to your unique situation, detailing every task necessary to complete prior to
                        opening.</p>-->
                </div>

                  <div class="col-md-4 col-md-preffix-1">
                    <div class="image-wrap img-width block-center postfix-2">
                       <!--  <img width="550" height="837" src="@/assets/images/elizabeth01.jpg" alt=""> -->
                      <img width="450" height="674" src="@/assets/images/elizabeth01.jpg" alt="">
                    </div>
                    <div class="image-wrap-4 lg-visible"></div>
                  </div>
              </div>
            </div>
        </section>
        <div class="row text_center_small">
          <div class="col-md-9 col-md-preffix-2 "><br><br>
            <p class="text-md-justify">Over the years, she has developed a unique method of skin care as well as her own line of products that enhance the natural beauty of one’s own skin from the inside out. Elizabeth’s combination of natural products, nutritional guidance and expert knowledge of skin composition has earned her great respect in the industry, as well as a loyal clientele. Because she is so devoted to her craft, Elizabeth adheres to very strict standards, employing a highly skilled staff who are trained in all services. </p>
          </div>
        </div>
        <!-- END Listen to  Your Soul-->

        <!-- Ultimate Spa  Experience -->
        <section class="well well-xs text-md-left text_center_small">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-md-preffix-1">
                <h2 data-text="Body">The <br class="md-visible">Experience</h2>
              </div>
            </div>
              <div class="row">
                <div class="col-md-5 col-md-preffix-1">
                    <p class="text-md-justify">The high expectations of her customers demand that Elizabeth remain current with all the newest technology, products and treatment methods based on the latest scientific research. Elizabeth’s holistic approach to skin care has earned her a very loyal followingwith clients that continue to comeback year after year. Servicesrange from Professional.</p>
                </div>
                <div class="col-md-5 col-md-preffix-1">
                    <p class="text-md-justify">Elizabeth welcomes you to the luxurious experience of total skin care in a beautiful, professional environment. Come to Elizabeth Skin Care salon for the pampering you deserve. “What I learned from my own mother about skin care left a lasting impression on me. Let my exceptional treatment leave a lasting impression on you.” </p>
                  </div>

              </div>
            </div>
        </section>
        <!-- END Ultimate Spa  Experience-->
        <h5 class="text-center">Welcome to Elizabeth’s Salon.</h5>
        <div class="divider-1"></div>
    </main>

</template>

<script>
  export default {
    name: 'AboutUs',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  display: block;
  margin: 0 auto;
}
</style>
